import React from 'react'
import { Routes, Route } from 'react-router-dom';
import Signup from '../components/Auth/Signup';
import Login from '../components/Auth/Login';
import Enterotp from '../components/Auth/Enterotp';
import VerifyOtp from '../components/Auth/VerifyOtp';
import ConnetPayment from '../components/Auth/ConnetPayment';
import Step1 from '../components/Auth/profile/Step1';
import Step2 from '../components/Auth/profile/Step2';
import Step3 from '../components/Auth/profile/Step3';
import ProtectedRoutes from '../components/ProtectedRoutes';
import UnprotectedRoutes from 'components/UnprotectedRoutes';
import Home from '../Dashboard/Home/Home';
import MyProfile from 'Dashboard/Dashboardpages/MyProfile';
import Myjobs from 'Dashboard/Dashboardpages/Myjobs';
import MyBids from 'Dashboard/Dashboardpages/MyBids';
import EmergencyAlerts from 'Dashboard/Dashboardpages/EmergencyAlerts';
import AboutUs from 'Dashboard/Dashboardpages/AboutUs';
import Faq from 'Dashboard/Dashboardpages/Faq';
import Terms from 'Dashboard/Dashboardpages/Terms';
import Privacy from 'Dashboard/Dashboardpages/Privacy';
import ChatWindow from 'Dashboard/Chatwindow/ChatWindow';
import AvailableJobs from 'Dashboard/Dashboardpages/AvailableJobs';
import JobsPage from 'Dashboard/Dashboardpages/JobsPage';
import DashboardLayout from 'Layout/DashboardLayout';
import JobDetailsPage from 'Dashboard/Dashboardpages/JobDetailsPage';

import MissingPersonDetails from 'Dashboard/Dashboardpages/MissingPDetails';
import DisasterAlert from 'Dashboard/Dashboardpages/DisasterAlert';
import StripeConnect from 'components/Modals/Clientpanelpipup/StripeConnect';
import BidDetailsPage from 'Dashboard/Dashboardpages/BidDetailsPage';
import AdvertisementAlert from 'Dashboard/Dashboardpages/AdvertisementAlert';
import Contact from 'views/Public/Contact';
import Advertisement from 'components/Dashboard/Advertisement';
import MyFiles from 'Dashboard/Dashboardpages/MyFiles';
import StripeAlertpage from 'Dashboard/Dashboardpages/StripeAlertpage';
import NotificationList from 'Dashboard/Dashboardpages/NotificationList';
import Advertise from 'views/Public/Advertise';
import TermsSection from 'views/Public/TermsConditions';
import NotFound from 'views/NotFound';
import PilotOptimization from 'views/PilotOptimization';
import PrivacyPolicy from 'views/Public/PrivacyPolicy';
import AboutUsSection from 'views/Public/AboutUs';
// import LandingPage from 'views/Home';
import MainLayout from 'Layout/MainLayout';

const MainRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<MainLayout />}>
        {/* <Route index element={<LandingPage />} /> */}
        
        <Route path="privacy-section" element={<PrivacyPolicy />} />
        <Route path="terms-section" element={<TermsSection />} />
        <Route path="contact" element={<Contact isOutSideCalled={true} />} />
        <Route path="advertise" element={<Advertise />} />
        <Route path="about-section" element={<AboutUsSection />} />
        <Route path="*" element={<NotFound />} />
      </Route>
      <Route element={<UnprotectedRoutes />}>
      <Route index element={<Login />} />
        <Route path="signup" element={<Signup />} />
        <Route path="login" element={<Login />} />
        <Route path="enter-otp" element={<Enterotp />} />
      </Route>
      <Route element={<ProtectedRoutes />}>
        <Route path="/connect" element={<StripeAlertpage />} />
        <Route element={<DashboardLayout />}>
          <Route index path="/dashboard" element={<Home />} />
          <Route index path="/pilot-optimization" element={<PilotOptimization />} />
          <Route path="my-jobs">
            <Route index element={<Myjobs />} />
            <Route path=":id" element={<JobDetailsPage />} />
          </Route>
          <Route path="my-bids">
            <Route index element={<MyBids />} />
            <Route path=":id" element={<BidDetailsPage />} />
          </Route>
          <Route path="my-files" element={<MyFiles />} />
          <Route path="notification" element={<NotificationList />} />
          {/* <Route path="notification-list/:id" element={<NotificationDetails />} /> */}
          <Route path="emergency" element={<EmergencyAlerts />} />
          <Route path="advertisepage" element={<Advertisement />} />
          <Route path="missingdetails/:id" element={<MissingPersonDetails />} />
          <Route path="disasterdetails/:id" element={<DisasterAlert />} />
          <Route path="advertisement/:id" element={<AdvertisementAlert />} />
          <Route path="stripe" element={<StripeConnect />} />
          <Route path="contact-form" element={<Contact isOutSideCalled={false} />} />
          <Route path="my-profile" element={<MyProfile />} />
          <Route path="available-jobs">
            <Route index element={<AvailableJobs />} />
            <Route path=":id" element={<JobsPage />} />

          </Route>
          <Route path="faq" element={<Faq />} />
          <Route path="about-us" element={<AboutUs />} />
          <Route path="chat" element={<ChatWindow />} />
          <Route path="privacy-policy" element={<Privacy />} />
          <Route path="terms-policy" element={<Terms />} />
        </Route>
        <Route path="verify-otp" element={<VerifyOtp />} />
        <Route path="ConnetPayment" element={<ConnetPayment />} />
        <Route path="profileStep1" element={<Step1 />} />
        <Route path="profileStep2" element={<Step2 />} />
        <Route path="profileStep3" element={<Step3 />} />
        {/* <Route path="about-section" element={<AboutUs />} /> */}
      </Route>
    </Routes>
  )
}

export default MainRoutes
